/* custom-cl-facts.js — mobile facts-table expander (rows 5+ behind "виж всички") */
(() => {
  document.querySelectorAll('[data-cl-facts-toggle]').forEach((btn) => {
    const table = document.getElementById(btn.getAttribute('aria-controls'));
    if (!table) return;
    const label = btn.querySelector('[data-cl-facts-label]');
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      table.classList.toggle('is-collapsed', expanded);
      if (label) label.textContent = expanded ? btn.dataset.labelMore : btn.dataset.labelLess;
      if (expanded) table.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
